import React, { useMemo, useState } from "react";
import ModalPatrocinador from "./modalPatrocinador";

function AreaPatrocinadores(props) {
  const [patrocinador, setPatrocinador] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const patrocinadores = useMemo(() => {
    const lista = props.patrocinadores;
    if (!Array.isArray(lista)) return [];

    const idsExtra = Array.isArray(props.id_extra) ? props.id_extra : [];

    // Quando há id_extra, a seção é montada só com esses IDs e na ordem do array
    if (idsExtra.length > 0) {
      const porId = new Map(lista.map((p) => [p.id, p]));
      return idsExtra.map((id) => porId.get(id)).filter(Boolean);
    }

    const idsCota = Array.isArray(props.id_cota)
      ? props.id_cota
      : [props.id_cota];

    return lista.filter((p) => idsCota.includes(p.id_plano));
  }, [props.patrocinadores, props.id_cota, props.id_extra]);

  const comLogo = useMemo(
    () => patrocinadores.filter((p) => Boolean(p?.logo)),
    [patrocinadores]
  );

  const handleModalPatrocinio = (item) => {
    setPatrocinador(item);
    setShowModal(true);
  };

  const fecharModal = () => {
    setShowModal(false);
  };

  if (comLogo.length === 0) return null;

  return (
    <section
      className="patrocinio-cota"
      aria-labelledby={`cota-titulo-${props.cota}`}
    >
      <ModalPatrocinador
        titulo="Validação do evento"
        show={showModal}
        toggleModal={fecharModal}
        item={patrocinador}
      />

      <h2 className="cota" id={`cota-titulo-${props.cota}`}>
        {props.cota}
      </h2>

      <ul className="area-patrocinador" role="list">
        {comLogo.map((p) => (
          <li key={p.id} className="patrocinador-item">
            <button
              type="button"
              className="patrocinador-logo-btn"
              onClick={() => handleModalPatrocinio(p)}
              aria-label={`Ver detalhes de ${p.patrocinador || "patrocinador"}`}
            >
              <img
                src={p.logo}
                className="imagem-logo"
                alt={p.patrocinador || "Logo do patrocinador"}
              />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default AreaPatrocinadores;
